import { render, staticRenderFns } from "./DossierLotsPanel.vue?vue&type=template&id=597056fc&scoped=true"
import script from "./DossierLotsPanel.vue?vue&type=script&lang=ts"
export * from "./DossierLotsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597056fc",
  null
  
)

export default component.exports